// React subscriptions to Yjs types. Components re-render when the observed type (deeply) changes.
import { useEffect, useReducer } from 'react';
import type * as Y from 'yjs';

export function useYVersion(type: Y.AbstractType<any> | undefined | null): number {
  const [version, bump] = useReducer((n: number) => n + 1, 0);
  useEffect(() => {
    if (!type) return;
    const on = () => bump();
    type.observeDeep(on);
    return () => type.unobserveDeep(on);
  }, [type]);
  return version;
}

/** Re-renders when the awareness states change (presence). */
export function useAwarenessVersion(awareness: { on: Function; off: Function } | null | undefined): number {
  const [version, bump] = useReducer((n: number) => n + 1, 0);
  useEffect(() => {
    if (!awareness) return;
    const on = () => bump();
    awareness.on('change', on);
    return () => awareness.off('change', on);
  }, [awareness]);
  return version;
}
